import { xglobal } from '@polkadot/x-global';
export { packageInfo } from './packageInfo.js';
export const fetch = xglobal.fetch;
